const Client = require("./ModHttpsClient")

module.exports = {
    default: "CH",   
    readAll(locale) {
        return Client.get(locale ? [{
            key: "lang",
            value: locale
        }] : null, {
            path: "/country/read/all"
        })
    },
    toOptions(array, translatedOnly = false) {
        let options = []
        for (let i = 0, len = array.length; i < len; i++) {
            if (translatedOnly && this.translated.includes(array[i].id)){
                options.push({
                    value: array[i].id,
                    text: array[i].name
                })
            } else if (translatedOnly===false) {
                options.push({
                    value: array[i].id,
                    text: array[i].name
                })
            }
        }
        return options
    }
}